import AccountController from "@/js/Webmail/AccountController";

export { QuotaHTTPMapping as default };

/**
* Handles All Folder Messages Data
*
* @author      rsommerfeld <roni.s.sommerfeld@altice.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class QuotaHTTPMapping {
  /**
   * Handle data to Quota
   *
   * @param {MailboxQuotaItem} mailbox_quota
   * @param {Object} results
   *
   * @since 7.0.0
   *
   * @returns {void}
   */
  mapFolderQuota(mailbox_quota, results) {
    mailbox_quota.message                  = results.msg_f;
    mailbox_quota.storage_used             = results.st_u;
    mailbox_quota.storage_used_gb          = (mailbox_quota.storage_used / 1024 / 1024 / 1024).toFixed(2);
    mailbox_quota.storage_limit            = results.st_l || AccountController.account.cos.quota_size;
    mailbox_quota.storage_limit_gb         = mailbox_quota.storage_limit / 1024 / 1024 / 1024;

    // To GB
    mailbox_quota.storage_virtual          = AccountController.account.cos.quota_virtual_size || 0;
    mailbox_quota.storage_virtual_gb       = mailbox_quota.storage_virtual / 1024 / 1024 / 1024;

    mailbox_quota.storage_percentage       = mailbox_quota.storage_limit > 0 ? (mailbox_quota.storage_used / mailbox_quota.storage_limit) * 100 : 0;
    mailbox_quota.storage_percentage       = Math.round(mailbox_quota.storage_percentage * 10) / 10;

    mailbox_quota.storage_virtual_percentage = mailbox_quota.storage_virtual > 0 ? (mailbox_quota.storage_used / mailbox_quota.storage_virtual) * 100 : 0;
    mailbox_quota.storage_virtual_percentage = Math.round(mailbox_quota.storage_virtual_percentage * 10) / 10;

    mailbox_quota.storage_percentage_bar = mailbox_quota.storage_virtual_percentage > 100 ? 100 : mailbox_quota.storage_virtual_percentage;

    // Calculate floor interval more than 30, 50, 70, 90
    if (mailbox_quota.storage_virtual_percentage >= 90) {
      mailbox_quota.storage_percentage_floor = 90;
    } else if (mailbox_quota.storage_virtual_percentage >= 70) {
      mailbox_quota.storage_percentage_floor = 70;
    } else if (mailbox_quota.storage_virtual_percentage >= 50) {
      mailbox_quota.storage_percentage_floor = 50;
    } else if (mailbox_quota.storage_virtual_percentage >= 30) {
      mailbox_quota.storage_percentage_floor = 30;
    } else {
      mailbox_quota.storage_percentage_floor = 0;
    }
  }
}